import { render, staticRenderFns } from "./DiseaseState.vue?vue&type=template&id=c0237118&"
import script from "./DiseaseState.vue?vue&type=script&lang=js&"
export * from "./DiseaseState.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseState.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports